export const SET_FOCUS_SECTION = 'SET_FOCUS_SECTION';
